import React from 'react';
import s from '../../pages/call-manager/CallManager.module.scss';

/** Reserved slot above member lists — avoids filter tabs jumping when banner toggles. */
export default function ActionBannerDock({ action, children }) {
  return (
    <div
      className={`${s.actionBannerDock}${action ? ` ${s.actionBannerDockActive}` : ''}`}
      aria-hidden={!action}
    >
      {action ? children : null}
    </div>
  );
}
